import { createSlice } from '@reduxjs/toolkit';
import { idUtils } from '~/utils/id-utils';
import { resetOnLogout } from '~/reducers/common-actions';

export const hiddenRoutesSlice = createSlice({
    name: 'hiddenRoutes',
    initialState: {},
    reducers: {
        setHiddenRoutes: (state, action) => {
            state = action.payload;
            return state;
        },
        addHiddenRoute: (state, action) => {
            state[action.payload] = true;
            return state;
        },
        addHiddenRoutes: (state, action) => {
            const clientRouteIds = action.payload;
            clientRouteIds.forEach((id) => {
                state[id] = true;
            });
            return state;
        },
        removeHiddenRoute: (state, action) => {
            delete state[action.payload];
            return state;
        },
        removeHiddenRoutes: (state, action) => {
            const clientRouteIds = action.payload;
            clientRouteIds.forEach((id) => {
                delete state[id];
            });
            return state;
        },
        showClientRoutes: (state, action) => {
            const clientId = action.payload;
            for (const key in state) {
                if (idUtils.splitCombinedId(key)[0] === clientId) {
                    delete state[key];
                }
            }
            return state;
        },
        hideRoutes: (state, action) => {
            for (const clientRouteId of action.payload) {
                state[clientRouteId] = true;
            }
            return state;
        },
        resetHiddenRoutes: () => {
            return {};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return {};
        });
    }
});

export const {
    setHiddenRoutes,
    addHiddenRoute,
    removeHiddenRoute,
    addHiddenRoutes,
    removeHiddenRoutes,
    showClientRoutes,
    hideRoutes,
    resetHiddenRoutes
} = hiddenRoutesSlice.actions;
export const selectHiddenRoutes = (state) => state.hiddenRoutes;
export default hiddenRoutesSlice.reducer;
